import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';


type SliceModel = {
    id: string,
    msg: string;
};
const sliceName: string = 'gridErrors';

export const gridErrorAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id,
});
export const gridErrorSlice = createSlice({
    name: sliceName,
    initialState: gridErrorAdapter.getInitialState(),
    reducers: {
        addMany: gridErrorAdapter.addMany,
        addOne: gridErrorAdapter.addOne,
        updateMany: gridErrorAdapter.updateMany,
        updateOne: gridErrorAdapter.updateOne,
        upsertOne: gridErrorAdapter.upsertOne,
        upsertMany: gridErrorAdapter.upsertMany,
        removeOne: gridErrorAdapter.removeOne
    }
});
